import { render, staticRenderFns } from "./sumProblem.vue?vue&type=template&id=ff1c472a&scoped=true"
import script from "./sumProblem.vue?vue&type=script&lang=js"
export * from "./sumProblem.vue?vue&type=script&lang=js"
import style0 from "./sumProblem.vue?vue&type=style&index=0&id=ff1c472a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1c472a",
  null
  
)

export default component.exports